import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@keobook/ui/styles.css';
import { installGlobalErrorHandlers } from './lib/error-report';
import { App } from './App';

// DSN-free error tracking: catch errors that escape React (async / promises /
// event handlers) and relay them to Google Cloud Error Reporting via the API.
// React render errors are caught by the ErrorBoundary inside <App/>.
installGlobalErrorHandlers();

const root = document.getElementById('root');
if (!root) throw new Error('#root not found in index.html');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
